<template>
  <div class="jobs">
    <div class="banner"></div>

    <!-- 搜索 -->
    <div
      ref="searchBar"
      :class="{ fixedTop: searchBarFixedTop }"
      class="search-wrapper"
    >
      <input-search
        :size="searchBarFixedTop ? 'small' : 'medium'"
        placeholder="搜索职位"
        v-model="searchKeyword"
      ></input-search>
    </div>

    <div class="main clearfix">
      <!-- 条件筛选 -->
      <div class="screen-wrapper">
        <div class="CationBox">
          <div class="row">
            <div class="name">城市：</div>
            <div class="content">
              <div
                v-for="(item, index) in cityList"
                :key="index"
                @click="submit(item, 1)"
                :class="['item', cityVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
              <div :class="['item', flag ? 'actvCss' : '']" @click="onClick">
                自定义
              </div>
              <div class="item-input" v-if="flag">
                <input type="text" class="input" v-model="city" />
                <el-button type="primary" size="mini" @click="submit(city, 2)"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="name">薪资：</div>
            <div class="content">
              <div
                v-for="(item, index) in salaryList"
                :key="index"
                @click="salarySubmit(item.value)"
                :class="['item', salaryVar == item.value ? 'actvCss' : '']"
              >
                {{ item.label }}
              </div>
              <div class="item-input" v-if="show">
                <el-input
                  class="input"
                  size="small"
                  min="1"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-model="salaryStart"
                >
                  <template
                    slot="append"
                    v-if="salaryVar == '1' || salaryVar == '2'"
                    >K</template
                  >
                </el-input>
                <span style="padding-right: 10px">-</span>
                <el-input
                  class="input"
                  size="small"
                  min="1"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-model="salaryEnd"
                >
                  <template
                    slot="append"
                    v-if="salaryVar == '1' || salaryVar == '2'"
                    >K</template
                  >
                </el-input>
                <el-button type="primary" size="mini" @click="salarySub"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="name">币种：</div>
            <div class="content">
              <div
                v-for="(item, index) in salaryCurrencyType"
                :key="index"
                @click="salaryCurrencyVar = item.value"
                :class="[
                  'item',
                  salaryCurrencyVar == item.value ? 'actvCss' : '',
                ]"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="name">经验：</div>
            <div class="content">
              <div
                v-for="(item, index) in termList"
                :key="index"
                @click="termVar = item"
                :class="['item', termVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="name">学历：</div>
            <div class="content">
              <div
                v-for="(item, index) in educationList"
                :key="index"
                @click="educationSubmit(item)"
                :class="['item', educationVar.includes(item) ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div
            class="screen-row"
            v-if="
              (cityVar != '全部' && cityVar != '') ||
              !educationVar.includes('全部') ||
              termVar != '全部' ||
              salaryCurrencyVar != '全部' ||
              salaryType != ''
            "
          >
            <div class="name">已选择：</div>
            <div class="content">
              <div
                class="item actvCss"
                v-if="cityVar != '全部' && cityVar != ''"
                @click="clearCity"
              >
                {{ cityVar }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div
                class="item actvCss"
                v-for="(item, i) in educationVar"
                @click="clearEducation(item)"
                v-if="item != '全部'"
              >
                {{ item }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div
                class="item actvCss"
                v-if="termVar != '全部'"
                @click="termVar = '全部'"
              >
                {{ termVar }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div class="item actvCss" v-if="salaryType != ''" @click="onCear">
                {{ salaryList.find((item) => item.value == salaryType).label
                }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div class="item actvCss" v-if="salary != ''" @click="onCear">
                {{ salary }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div
                class="item actvCss"
                v-if="salaryCurrencyVar != '全部'"
                @click="salaryCurrencyVar = '全部'"
              >
                {{
                  salaryCurrencyType.find(
                    (item) => item.value == salaryCurrencyVar
                  ).label
                }}<i class="el-icon-close el-icon--right"></i>
              </div>
            </div>
            <div>
              <el-button
                type="text"
                icon="el-icon-delete-solid"
                @click="clearFilter"
                >清空筛选条件</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="content" v-loading:#ffffff7d.scrollFixed="loading">
        <ul class="content-list">
          <li
            class="recommend-job-item"
            v-for="(item, index) in jobsList"
            :key="index"
          >
            <a :href="'/jobDetail/' + item.jobId" target="_blank">
              <!-- <router-link :to="'/jobDetail/' + item.jobId"> -->
              <div class="job-top-container">
                <div class="job-top">
                  <div class="job-name">{{ item.job }}</div>
                  <div class="wage">{{ item.startSalary }}</div>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
              </div>
              <!-- </router-link> -->
            </a>
            <div class="company-bottom">
              <!-- <img
                src="https://iguopin-company.oss-cn-beijing.aliyuncs.com/10685379671379573/logo/20230619/16bfc9fe61492ed18920f2ca9d44f003.jpg"
                alt="LOGO"
                class="company-logo-box"
              /> -->
              <div class="company-desc">
                <a :href="'/companyDetail/' + item.companyId" target="_blank">
                  <!-- <router-link :to="'/companyDetail/' + item.companyId"> -->
                  <div class="company-name substring">
                    {{ item.companyName }}
                  </div>
                  <!-- </router-link> -->
                </a>
                <!-- <div class="company-tag substring">
                  <span class="tag">国企</span
                  ><span class="tag">科学研究和技术服务业</span>
                </div> -->
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryFilter.pageNum"
            :limit.sync="queryFilter.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOffsetTop } from "@/helper/utilities";
let positionY = 0;
let searchBarClientHeight = 0;
import { getJobsList } from "@/api/index.js";
import store from "@/store";
export default {
  name: "jobs",
  metaInfo: {
    title: "职位_招聘引才_考试测评_人才培训_管理咨询",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { hid: "description", name: "description", content: "职位" },
      {
        name: "keywords",
        content: "湖北人才网, 湖北省人才发展集团, 湖北省人才发展集团有限公司",
      },
    ],
  },
  data() {
    return {
      cityList: [
        "全部",
        "北京",
        "上海",
        "广州",
        "深圳",
        "杭州",
        "苏州",
        "南京",
        "武汉",
        "西安",
        "重庆",
        "成都",
        "大连",
      ],
      educationList: ["全部", "博士", "硕士", "本科", "大专"],
      termList: [
        "全部",
        "无工作经验",
        "1年以下工作经验",
        "1年-3年工作经验",
        "3年-5年工作经验",
        "5年-10年工作经验",
        "10年以上工作经验",
      ],
      salaryList: [
        // "全部",
        // "月薪",
        // "年薪"
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "0",
          label: "面议",
        },
        {
          value: "1",
          label: "月薪",
        },
        {
          value: "2",
          label: "年薪",
        },
        {
          value: "3",
          label: "日薪",
        },
        {
          value: "4",
          label: "时薪",
        },
      ],
      salaryCurrencyType: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "0",
          label: "人民币",
        },
        {
          value: "1",
          label: "美元",
        },
        {
          value: "2",
          label: "欧元",
        },
      ],
      flag: false,
      show: false,
      cityVar: "全部",
      city: "",
      educationVar: ["全部"], // 表示当前选中的学历
      educationNameForSearch: [],
      termVar: "全部", // 表示当前选中的经验
      salaryVar: "全部", // 表示当前选中的薪资
      salaryType: "",
      salaryStart: "",
      salaryEnd: "",
      salaryStartForSearch: "",
      salaryEndForSearch: "",
      salary: "",
      salaryCurrencyVar: "全部",
      jobsList: [],
      // 查询参数
      searchKeyword: "",
      currentPage: 1,
      // 总条数
      total: 0,
      searchBarFixedTop: false,
      loading: false,
    };
  },
  computed: {
    // ComDataList() {
    //   return this.DataList.filter((item) => {
    //     if (
    //       (this.cityVar == "全部" || this.cityVar == item.Platform) &&
    //       (this.salaryVar == "全部" || this.salaryVar == item.Platform) &&
    //       (this.termVar == "全部" || this.termVar == item.Type) &&
    //       (this.salaryVar == "全部" || this.salaryVar == item.Condition)
    //     ) {
    //       return item; // 把符合条件的数据返回,模板中通过this.ComDataList可直接动态读取数据
    //     }
    //   });
    // },
    queryFilter() {
      let serviceName;
      if (this.termVar == "全部") {
        serviceName = "";
      } else {
        serviceName = this.termVar;
      }
      let educationNameForSearchStr;
      if (this.educationVar == "全部") {
        educationNameForSearchStr = "";
      } else {
        educationNameForSearchStr = this.educationVar.toString();
      }
      let workingCity;
      if (this.cityVar == "全部") {
        workingCity = "";
      } else {
        workingCity = this.cityVar;
      }
      let salaryCurrency;
      if (this.salaryCurrencyVar == "全部") {
        salaryCurrency = "";
      } else {
        salaryCurrency = this.salaryCurrencyVar;
      }
      return {
        // cityVar: this.cityVar,
        workingCity: workingCity,
        educationNameForSearchStr: educationNameForSearchStr,
        serviceName: serviceName,
        salaryCurrency: salaryCurrency,
        salaryType: this.salaryType,
        salaryStartForSearch: this.salaryStartForSearch,
        salaryEndForSearch: this.salaryEndForSearch,
        pageNum: 1,
        pageSize: 10,
        search: this.searchKeyword || "",
      };
    },
  },
  watch: {
    queryFilter(newVal, oldVal) {
      this.searchBarFixedTop && window.scrollTo(0, positionY);
      this.getList();
    },
    searchKeyword(newVal) {
      this.updateRouteParams(newVal);
    },
  },
  mounted() {
    this.$nextTick(() => {
      positionY = getOffsetTop(document.body, this.$refs.searchBar);

      searchBarClientHeight = this.$refs.searchBar.clientHeight;
    });
    const onPageScroll = () => {
      const top = this.$refs.searchBar.getBoundingClientRect().top;

      this.searchBarFixedTop =
        window.scrollY > positionY - searchBarClientHeight / 2;
    };
    window.addEventListener("scroll", onPageScroll);

    this.$on("hook:destroyed", () => {
      window.removeEventListener("scroll", onPageScroll);
    });
  },
  created() {
    this.searchKeyword = this.$route.query.keyword;
    store.setKeyword(this.$route.query.keyword);
    this.getList();
  },
  methods: {
    clearFilter() {
      this.flag = false;
      this.show = false;
      this.cityVar = "全部";
      this.city = "";
      this.educationVar = ["全部"];
      this.termVar = "全部";
      this.salaryVar = "全部";
      this.salaryCurrencyVar = "全部";
      this.salary = "";
      this.salaryType = "";
      this.salaryStart = "";
      this.salaryEnd = "";
      this.salaryStartForSearch = "";
      this.salaryEndForSearch = "";
    },

    clearCity() {
      this.flag = false;
      this.cityVar = "全部";
      this.city = "";
    },

    onClick() {
      this.flag = true;
      this.cityVar = "";
    },

    submit(item, stuats) {
      if (item == "全部") {
        this.flag = false;
        this.city = "";
      } else if (stuats == 1) {
        this.flag = false;
      }
      this.cityVar = item;
    },

    onCear() {
      this.salaryVar = "全部";
      this.show = false;
      this.salary = "";
      this.salaryType = "";
      this.salaryStart = "";
      this.salaryEnd = "";
      this.salaryStartForSearch = "";
      this.salaryEndForSearch = "";
    },

    salarySubmit(val) {
      let found = this.salaryList.find((item) => item.value == val);
      if (val == "全部") {
        this.show = false;
        this.salaryType = "";
        this.salaryStart = "";
        this.salaryEnd = "";
        this.salaryStartForSearch = "";
        this.salaryEndForSearch = "";
      } else if (val == "0") {
        this.show = false;
        this.salaryType = found.value;
        this.salaryStart = "";
        this.salaryEnd = "";
        this.salaryStartForSearch = "";
        this.salaryEndForSearch = "";
        this.salary = "";
      } else {
        this.show = true;
      }
      this.salaryVar = found.value;
    },

    salarySub() {
      if (this.salaryStart && this.salaryEnd && this.salaryVar) {
        if (this.salaryVar == "3" || this.salaryVar == "4") {
          this.salaryStartForSearch = this.salaryStart;
          this.salaryEndForSearch = this.salaryEnd;
          this.salary = this.salaryStart + "-" + this.salaryEnd;
        } else {
          this.salaryStartForSearch = this.salaryStart + "000";
          this.salaryEndForSearch = this.salaryEnd + "000";
          this.salary = this.salaryStart + "-" + this.salaryEnd + "K";
        }
        if (this.salaryVar == "全部") {
          this.salaryType = "";
        } else if (this.salaryVar == "0") {
          this.salaryType = "";
        } else {
          this.salaryType = this.salaryVar;
        }
      } else {
        this.$message({
          showClose: true,
          message: "薪资范围不能为空",
          type: "warning",
        });
      }
    },

    educationSubmit(val) {
      if (val == "全部") {
        this.educationVar = ["全部"];
      } else {
        const filteredArray = this.educationVar.filter(
          (item) => item !== "全部"
        );
        filteredArray.push(val);
        this.educationVar = filteredArray.filter(
          (item, index) => filteredArray.indexOf(item) === index
        );
      }
    },

    clearEducation(val) {
      const filteredArray = this.educationVar.filter((item) => item !== val);
      this.educationVar = filteredArray;
      if (this.educationVar.length == 0) {
        this.educationVar = ["全部"];
      }
    },

    updateRouteParams(query) {
      if (query) {
        this.$router.push({ path: "/jobs", query: { keyword: query } });
      } else {
        this.$router.push({ path: "/jobs" });
      }
      store.setKeyword(query);
    },

    getList() {
      const loading = this.$loading();
      getJobsList(this.queryFilter)
        .then((response) => {
          loading.close();
          this.jobsList = response.data;
          this.total = response.total;
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.jobs {
  background-color: #f3f3f3;
  padding-bottom: 30px;
}
.banner {
  padding-bottom: 32%;
  line-height: 400px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../assets/images/yssdpc.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}
.search-wrapper {
  // position: absolute;
  width: 100%;
  // padding: 0 200px;
  transform: translateY(-50%);
  z-index: 100;
  &.fixedTop {
    position: fixed;
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0.1);
    top: 0;
    padding: 20px 130px;
    z-index: 1000;
    background-color: #fff;
    transform: translateY(0);
  }
}

.main {
  width: @main-width;
  margin: 0 auto;
  .screen-wrapper {
    width: @main-width;
    padding: 0 auto;
    .CationBox {
      width: @main-width;
      background-color: #fff;
      border-radius: 4px;
      padding: 30px 32px 18px;
    }
    .row > div {
      flex-shrink: 0;
      margin-right: 30px;
      font-size: 14px;
    }
    .row {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #f3f3f3;
    }
    .content {
      flex: 1;
      display: flex;
      .item {
        border-radius: 3px;
        color: #666;
        padding: 5px 15px;
        margin: 5px 0;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        border: 1px solid transparent;
      }
      .item-input {
        margin-left: 20px;
        margin: 5px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .input {
          width: 120px;
          height: 31px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      .actvCss {
        background: #39b8ff;
        color: #fff;
        margin-right: 5px;
      }
    }
    .screen-row > div {
      flex-shrink: 0;
      margin-right: 15px;
      font-size: 14px;
    }
    .screen-row {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      .item {
        margin: 0 10px;
      }
    }
  }
  .content-list {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .recommend-job-item:nth-child(2n) {
      margin-right: 0;
    }
    .recommend-job-item {
      background-color: #fff;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      margin-bottom: 21px;
      margin-right: 20px;
      padding: 13px 27px;
      width: 45%;
    }

    .job-top-container {
      border-bottom: 1px dotted #666;
      line-height: 30px;
      padding-bottom: 10px;
      .job-top {
        -ms-flex-align: center;
        -ms-flex-pack: justify;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        justify-content: space-between;
        .job-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .wage {
          flex: 1;
          justify-content: flex-end;
          display: flex;
          color: #d9011e;
          font-size: 16px;
          align-items: center;
          white-space: nowrap;
        }
      }
    }

    .substring {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      text-align: left;
    }
    .tag {
      font-size: 14px;
    }
    .tag:not(:first-child):before {
      content: "|";
      margin: 0 4px;
    }
    .company-bottom {
      -ms-flex-align: center;
      align-items: center;
      display: -ms-flexbox;
      display: flex;
      margin-top: 5px;
      .company-logo-box {
        height: 50px;
        margin-right: 20px;
        margin-top: 10px;
        -o-object-fit: contain;
        object-fit: contain;
        width: 50px;
      }
      img {
        border-style: none;
        vertical-align: middle;
      }
      .company-desc .company-tag {
        margin-top: 10px;
        width: 303px;
      }
    }
  }

  .pagination-wrapper {
    text-align: center;
  }
}
</style>
